import { TripItineraryItemType } from "~graphql/generated/graphql"
import type { TripItinerary } from "~graphql/generated/graphql"

export function getItineraryCheckInItems(itinerary?: TripItinerary | null) {
    const checkInItem = itinerary?.items.find(
        (item) => item.type === TripItineraryItemType.CheckIn
    )
    const checkOutItem = itinerary?.items.find(
        (item) => item.type === TripItineraryItemType.CheckOut
    )

    return {
        checkInItem,
        checkOutItem,
    }
}
